<template>
    <div id="DmhFinance">

        <div class="dmh-start-container content-container" v-if="selectedView === 'journey'">
            <div class="progress-bar-outer w-100">
                <div class="progress-bar-inner bg-brand-primary " :style="{ width: progressWidth + '%' }"></div>
            </div>
            <h2 class="dmh-start-title brand-text">{{ currentQuestion.question_text ? currentQuestion.question_text :
                currentQuestion.sub_heading }}</h2>
            <div class="dmh-options-container">
                <SingleSelectQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer" :answerQuestion="answerQuestion"
                    v-if="currentQuestion.question_type === 'select'"></SingleSelectQuestion>
                <DateTimeQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                    v-if="currentQuestion.question_type === 'date_time'"></DateTimeQuestion>
                <ConfirmQuestion :question="currentQuestion" :setAnswer="setAnswer"
                    v-if="currentQuestion.question_type === 'text'"></ConfirmQuestion>
                <DmhLocation question="currentQuestion" :setAnswer="setAnswer" v-if="currentQuestion.question_type === 'location_detection'"/>
                <TextQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                    v-if="currentQuestion.question_type === 'confirm'"></TextQuestion>
                <TextAreaQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                    v-if="currentQuestion.question_type === 'text_input'"></TextAreaQuestion>
                <SliderQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                    v-if="currentQuestion.question_type === 'slider'"></SliderQuestion>
                <div class="d-flex w-100 justify-content-end align-items-center pt-5 mt-3">
                    <b-button @click="getQuestion(questionHistory)" v-if="questionHistory.length !== 0" class="mr-5"
                        variant="cta-outline" size="lg" squared>Previous</b-button>
                    <b-button :disabled="currentAnswer === null || !allAnswersValid" variant="cta" size="lg" squared v-if="currentQuestion.question_type !== 'select'"
                        @click="answerQuestion()">Next</b-button>
                </div>
            </div>
            <div class="d-flex flex-row align-items-center justify-content-center w-100" v-if="questionHistory.length === 0">
                <div class="prompt-container d-flex flex-column align-items-center justify-content-center shadow w-100">
                    <SHPhoneNumbers/>
                    <b-button variant="cta-outline" size="lg" squared class="mt-5 mb-3" @click="initChat()">Live Chat</b-button>
                </div>
            </div>
        </div>
        <div class="dmh-options-container content-container" v-else-if="selectedView === 'booking'">
            <div class="d-flex flex-column align-items-center justify-content-center dmh-complete-container">
                <h3>Thank you!</h3>
                <p>Our Team will be in touch within 48 hours to confirm your appointment.</p>
                <b-button variant="cta" size="lg" @click="reset()">Return to 'My Health'</b-button>
            </div>
        </div>
    </div>
</template>
  
<script>
import axios from "axios";
import config from "../config/constants";
import SingleSelectQuestion from "@/components/DMH/SingleSelectQuestion"
import TextQuestion from "@/components/DMH/TextQuestion"
import TextAreaQuestion from "@/components/DMH/TextAreaQuestion"
import ConfirmQuestion from "@/components/DMH/ConfirmQuestion"
import SliderQuestion from "@/components/DMH/SliderQuestion"
import DateTimeQuestion from "@/components/DMH/DateTimeQuestion"
import DmhBooking from "@/components/DMH/DmhBooking"
import EventBus from "@/helpers/eventbus"


import { mapGetters } from "vuex";
import DmhLocation from "@/components/DMH/Location.vue";
import moment from "moment";
import SHPhoneNumbers from "../components/DMH/SHPhoneNumbers.vue";

export default {
    name: "DmhFinance",
    components: {
      DmhLocation,
        SingleSelectQuestion,
        TextQuestion,
        ConfirmQuestion,
        TextAreaQuestion,
        SliderQuestion,
        DateTimeQuestion,
        DmhBooking,
        SHPhoneNumbers,
    },
    mounted() { },
    data() {
        return {
            selectedView: 'journey',
            currentQuestion: null,
            currentAnswer: null,
            questionHistory: [],
            progressWidth: 0,
            financial: false,
        };
    },
    mounted() {
        this.getQuestion(false, 11);
        EventBus.$emit('updateNav', 'finance');
    },
    methods: {
        reset(){
            this.currentQuestion = null;
            this.questionHistory = [];
            this.currentAnswer = null;
            this.selectedView = 'journey';
            this.progressWidth = 0;
            this.getQuestion(false, 11);
            this.scrollToRef();
        },
        initChat() {
            let sf = document.getElementById('live-chat-widget');
            if (sf) {
                sf.style.display = "initial";
            } else {
                let script = document.createElement('script');
                script.src = "/assets/salesforce_Script.js";
                script.type = "text/javascript";
                script.charset = "UFT-8";
                script.setAttribute("id", "sf-script")
                document.head.appendChild(script);
            }
        },
        async getQuestion(questionHistory, questionId) {
            let question_id;
            if(questionHistory.length === 0){
                this.selectedOptionQId = null,
                this.selectedOptionIndex = null,
                this.selectedView = 'start'
                EventBus.$emit('updateNav', 'start');
            }
            if (questionHistory) {
                question_id = questionHistory.pop();
            }
            if (questionId) {
                if (questionId === 11) {
                    EventBus.$emit('updateNav', 'finance');
                } else {
                    EventBus.$emit('updateNav', 'mh');
                }
                if (questionId === 'faq') {
                    return this.$router.push('/faqs')
                }
                if (questionId === 'articles') {
                    return this.$router.push('/articles')
                }
                question_id = questionId;
            }
            const payload = {
                user_id: this.$store.getters.user_id,
                question_id,
                sdk_type: 'SH',
                sdk_version: '1.2.4'
            }
            let res = await axios.post(config.api_env + '/application/api/u/dmh/get-question', payload, config.options)
            if (res.data.success) {
                if (questionId) {
                    this.selectedView = 'journey'
                }
                this.currentQuestion = res.data.question
                if (['location_detection', 'text'].includes(res.data.question.question_type)) {
                    this.currentAnswer = true
                } else if (res.data.question.question_type === 'confirm') {
                    let answer = {};
                    res.data.question.options.forEach((o) => {
                        answer[o.field_key] = o.data
                    });
                    this.currentAnswer = answer;
                } else if (res.data.question.question_type === 'slider') {
                    let answer = {};
                    res.data.question.sliders.forEach((s) => {
                        answer[s.slider_text] = s.options[2];
                    });
                    this.currentAnswer = answer;
                } else {
                    this.currentAnswer = null;
                }
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.$store.dispatch("logout");
                this.$router.push("/login").catch((err) => { });
            }
        },
        async answerQuestion() {
            const payload = {
                user_id: this.$store.getters.user_id,
                answered_question_id: this.currentQuestion.question_id,
                answer: this.currentAnswer,
                sdk_type: 'SH',
                sdk_version: '1.2.4'
            }
            let res = await axios.post(config.api_env + '/application/api/u/dmh/answer-question', payload, config.options)
            if (res.data.success) {
                this.questionHistory.push(this.currentQuestion.question_id);
                if (res.data.question === null) {
                    this.selectedView = 'booking';
                } else {
                    this.currentQuestion = res.data.question;
                }
                if (['location_detection', 'text'].includes(res.data.question.question_type)) {
                    this.currentAnswer = true
                } else if (res.data.question.question_type === 'confirm') {
                    let answer = {};
                    res.data.question.options.forEach((o) => {
                        answer[o.field_key] = o.data
                    });
                    this.currentAnswer = answer;
                } else if (res.data.question.question_type === 'slider') {
                    let answer = {};
                    res.data.question.sliders.forEach((s) => {
                        answer[s.slider_text] = s.options[2];
                    });
                    this.currentAnswer = answer;
                } else {
                    this.currentAnswer = null;
                }
                this.scrollToRef();
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.$store.dispatch("logout");
                this.$router.push("/login").catch((err) => { });
            }
        },
        setAnswer(answer, type) {
            this.currentAnswer = answer;
        },
        selectOptionIndex(i, id) {
            this.selectedOptionQId = id;
            this.selectedOptionIndex = i;
            if (id === 11) {
                this.financial = true;
            } else {
                this.financial = false;
            }
        },
    },
    computed: {
        allAnswersValid() {
            if (this.currentQuestion.question_type === 'location_detection') return true;
            if (this.currentQuestion.question_type === 'date_time'){
                return moment(this.currentAnswer).diff(moment(), 'hours') > 48;
            } 
            const validationResults = this.validateDmhAnswers(this.currentAnswer);
            return validationResults ? Object.values(validationResults).every(value => value === true) : true;
        },
        ...mapGetters(["user"]),
    },
    watch: {
        questionHistory(value) {
            let progressWidth = value.length / 5;
            progressWidth = progressWidth * 100
            this.progressWidth = progressWidth
        }
    },
};
</script>
<style lang="less">
#DmhFinance {
    padding: 70px 0;
    min-height: 100%;
    background-color: #fff;

    .progress-bar-outer {
        max-width: 650px;
        background-color: #DBDBDB;
        height: 6px;
        border-radius: 5px;
        margin-bottom: 40px;

        .progress-bar-inner {
            border-radius: 6px;
            height: 100%;
        }
    }

    .dmh-start-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 800px;
        .prompt-container{
            margin-top: 20px;
            padding: 25px;
            max-width: 650px;
            border-radius: 16px;
            background-color: white;
        }
        .dmh-start-title {
            width: 100%;
            max-width: 650px;
            text-align: left;
            font-size: 2.2rem;
            letter-spacing: 0;
            font-family: "PlusJakartaSansBold";
        }
        .dmh-prompt-title {
            padding: 0;
            margin-top: 0;
            margin-bottom: 30px;
            text-align: center;
            font-size: 2.2rem;
            letter-spacing: 0;
            
            font-family: "PlusJakartaSansBold";
        }
        .phone-item{
            font-size: 1.8rem;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: "PlusJakartaSansRegular";

            .phone-link{
                border-bottom: 1.5px solid;
                font-family: "PlusJakartaSansBold";

            }
        }

        .dmh-options-container {
            margin: 0 20px 20px;
            max-width: 650px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            width: 100%;


        }

    }

    .dmh-complete-container {
        font-size: 1.6rem;

        h3 {
            text-align: center;
            font-size: 2.4rem;
            letter-spacing: 0;
            font-family: "PlusJakartaSansBold";
        }

        p {
            padding-bottom: 30px;
            max-width: 450px;
            text-align: center;
        }
    }
}</style>
  